import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDisplayModal, useOwnerValidationStep } from 'context'
import { OwnerSubmitType } from 'context/types'
import { OWNER_SUBMIT_SCHEMA } from 'context/validations'
import { Formik, FormikState } from 'formik'

import { CardCustomResult } from 'components/CardCustomResult'
import { CardBody, CardContainer } from 'components/CustomCard'
import { CustomModal } from 'components/CustomModal'
import { SubmitButton } from 'components/InputCustom'
import { customToast } from 'components/ToastCustom'

import { StepOne } from './components/StepOne'
import { StepTwo } from './components/StepTwo'

type OwnerValidationRouterProps = { vin: string }

export const OwnerValidation = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { openDialog, closeModal } = useDisplayModal()
  const { clearError, clearContent, sendOwnerDocuments,
    ownerValidationState: { error, loading, state: { isResult } } } = useOwnerValidationStep()
  const [vin, setVin] = useState<string | null>('')

  const initialValues: OwnerSubmitType = {
    fileOne: null,
    fileTwo: null,
    fileThree: null,
  }

  useEffect(() => {
    let vin = null

    if (location.state) ({ vin } = location.state as OwnerValidationRouterProps)
    setVin(vin)
  }, [location])

  useEffect(() => {
    if (loading)
      openDialog({
        content: <CustomModal type='secondary' title={'Enviando  documentos...'} />,
        variant: 'secondary'
      })
    else if (isResult || error) closeModal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, isResult, error])

  useEffect(() => {
    error && customToast.showToast({ description: error })
    clearError()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  const handleOnSubmit = (values: OwnerSubmitType) => sendOwnerDocuments(values, vin || '')

  const handleClose = (resetForm: (nextState?: Partial<FormikState<OwnerSubmitType>> | undefined) => void) => {
    navigate('/my-vehicles')
    resetForm()
    clearContent()
  }

  const handleGoBack = () => {
    navigate('/my-vehicles')
  }

  return (
    <Formik
      enableReinitialize
      validateOnMount
      initialValues={initialValues}
      onSubmit={handleOnSubmit}
      validationSchema={OWNER_SUBMIT_SCHEMA}>
      {({ values, setFieldValue, resetForm }) => (
        <CardContainer isScreen onClose={handleGoBack} headerText={'Validación de documentos'} hiddenStack={isResult}>
          <CardBody>
            {!isResult
              ? <>
                <StepOne values={values} setFieldValue={setFieldValue} />
                <StepTwo values={values} setFieldValue={setFieldValue} />
                <SubmitButton loadingText={'Enviando...'} isLoading={loading}>
                  {'enviar'}
                </SubmitButton>
              </>
              : <CardCustomResult
                onSubmit={() => handleClose(resetForm)}
                headerTitle={'Documentos enviados con éxito'}
                text={'Te contactaremos a tu correo las próximas 24 horas hábiles, un ejecutivo validará tus'
                  + ' documentos y podrás retomar el trámite.'} />
            }
          </CardBody>
        </CardContainer>
      )}
    </Formik>
  )
}

